












































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import draggable from 'vuedraggable'
import PlayPane from './playPane.vue'
import { getMyList } from '@/api/res'
import { shrinkSetData } from '@/util/dragThumb'

@Component({
  components: {
    draggable,
    PlayPane
  }
})
export default class MyList extends ViewBase {
  loading = false

  list: any[] = []

  get dragGroup() {
    return {
      name: 'playList',
      pull: 'clone',
      revertClone: true,
      put: (to: any, from: any, dragEl: HTMLElement, ev: DragEvent) => {
        if (to == from) {
          return true
        }
        return false
      }
    }
  }

  shrinkSetDataIn(dataTransfer: DataTransfer, dragEl: HTMLElement) {
    shrinkSetData(dataTransfer, dragEl.firstChild as HTMLElement)
  }

  mounted() {
    this.fetchList()
  }

  async fetchList() {
    this.loading = true
    try {
      const { data } = await getMyList()
      this.list = (data || []).filter((it: any) => it.resource_list.length > 0)
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.loading = false
    }
  }
}
